const streamIdPattern = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}'
const streamDestinationPattern = new RegExp(`^/stream/${streamIdPattern}$`, 'i')
const streamInvitePagePattern = new RegExp(`^/stream/${streamIdPattern}/invite(?:[?#].*)?$`, 'i')

function isInviteFallbackDestination(path) {
    return typeof path === 'string' && streamDestinationPattern.test(path)
}

function isAttemptedInviteDestination(path) {
    if (typeof path !== 'string') return false

    return streamInvitePagePattern.test(path)
}

// Only same-origin relative paths ("/foo?x#y"). Rejects "//host", "/\host" and encoded variants,
// which browsers treat as scheme-relative URLs.
const UNSAFE_PATH_CHARS = /[\\\u0000-\u001f\u007f]/

export function isSafeRelativePath(path) {
    if (typeof path !== 'string' || !path.startsWith('/')) return false
    if (UNSAFE_PATH_CHARS.test(path)) return false
    let decoded = path
    for (let i = 0; i < 3; i++) {
        try {
            const next = decodeURIComponent(decoded)
            if (next === decoded) break
            decoded = next
        } catch (_error) {
            // Malformed escape (e.g. "q=100%"): browsers don't decode paths, so keep what we have.
            break
        }
    }
    if (UNSAFE_PATH_CHARS.test(decoded)) return false
    return !decoded.startsWith('//')
}

export function resolvePostAuthPath(
    fallbackPath = '/',
    isNewSignup = false,
    storage = sessionStorage,
) {
    const key = 'attempted_path'
    const attemptedPath = storage.getItem(key)
    storage.removeItem(key)

    if (isNewSignup) {
        if (isInviteFallbackDestination(fallbackPath)) {
            return fallbackPath
        }
        if (isAttemptedInviteDestination(attemptedPath)) {
            return attemptedPath
        }
        return '/'
    }

    if (
        isSafeRelativePath(attemptedPath) &&
        !attemptedPath.startsWith('/login') &&
        !attemptedPath.startsWith('/signup')
    ) {
        return attemptedPath
    }

    return fallbackPath
}

export function navigateAfterAuth({
    embedded = false,
    navigate,
    fallbackPath = '/',
    isNewSignup = false,
}) {
    const targetPath = resolvePostAuthPath(fallbackPath, isNewSignup)

    if (embedded) {
        const currentPath = `${window.location.pathname}${window.location.search}${window.location.hash}`

        if (targetPath === currentPath) {
            window.location.reload()
            return
        }

        window.location.assign(targetPath)
        return
    }

    navigate(targetPath, { replace: true })
}
